import React from "react";

// plugin
import {
	Link,
	Trans,
	useTranslation,
} from "@herob191/gatsby-plugin-react-i18next";

// style
import "./footer.scss";
import { StaticImage } from "gatsby-plugin-image";
import ContactScript from "../../contactScript/contactScript";
import Marquee from "../../marquee/marquee";
import FlashHover from "../../flashHover/flashHover";

// context

// component

// util

// svg

// component
export default function Footer() {
	const { t } = useTranslation();

	const footerLinks = [
		// {
		// 	text: t("Quiénes somos"),
		// 	to: "/quien",
		// },
		{
			text: t("Aviso legal"),
			to: "/legal/aviso",
		},
		{
			text: t("Cookies"),
			to: "/legal/cookies",
		},
		{
			text: t("Privacidad"),
			to: "/legal/privacidad",
		},
	];

	return (
		<>
			<footer>
				<ContactScript />

				<div className="footerLinks">
					{footerLinks.map((link, i) => (
						<FlashHover key={"footerLink" + i}>
							<Link to={link.to} className="p2 underline">
								{link.text}
							</Link>
						</FlashHover>
					))}
				</div>

				<StaticImage
					src="../../../images/KitDigital-banner-w.png"
					class="kitDigitalBanner"
					alt=""
				/>
			</footer>

			<Marquee className="footerMarquee">
				<span className="telita">
					Telita <Trans>estudio creativo</Trans> © {new Date().getFullYear()}{" "}
					Telita con
				</span>
			</Marquee>
		</>
	);
}
